"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragGuidelines = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DragGuidelines = function (_a) {
    var currentDragPercentage = _a.currentDragPercentage, allowedPercentageValues = _a.allowedPercentageValues, onGuidelineEnter = _a.onGuidelineEnter, onGuidelineLeave = _a.onGuidelineLeave, isVisible = _a.isVisible;
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: isVisible, timeout: kaleidoscope_1.AnimationDuration.Medium, classNames: "side-by-side__drag-guidelines-" },
        react_1.default.createElement("div", { className: "side-by-side__drag-guidelines" }, allowedPercentageValues.map(function (percentage) { return (react_1.default.createElement("div", { className: "drag-guidelines__line", key: percentage, onMouseEnter: function () {
                onGuidelineEnter(percentage);
            }, onMouseLeave: onGuidelineLeave },
            react_1.default.createElement("div", { className: "drag-guidelines__line-outer" },
                react_1.default.createElement("div", { className: (0, classnames_1.default)("drag-guidelines__line-inner", {
                        "drag-guidelines__line-inner--active": currentDragPercentage === percentage,
                    }) })))); }))));
};
exports.DragGuidelines = DragGuidelines;
